"use strict";

/**
 * @classdesc
 * Bildexport-Panel
 *
 * @class
 * @extends gc.gis.widget.GCPanel
 * @memberof gc.gis.module.GCImageExport
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {gc.gis.module.GCImageExport} options.module Modul-Instanz
 */
gc.gis.module.GCImageExport.Panel = function(options)
{
    var self = this;

    gc.gis.assert.isSet(options);
    gc.gis.assert.isInstance(options.module, gc.gis.module.GCImageExport);

	/**
	 * @type {gc.gis.module.GCImageExport}
	 * @private
	 */
	this._module = options.module;

	/**
	 * @type {gc.gis.util.GCForm}
	 * @private
	 */
	this._form = null;

    // Aktionsleiste
	this._export_button = new gc.gis.widget.GCItem({
		label: 'Bild herunterladen',
		className: 'btn btn-success',
		//icon: 'glyphicon glyphicon-save',
		click: function(evt)
        {
	        try
	        {
		        self._form.submit();
	        }
	        catch(err)
	        {
		        gc.gis.iface.log.error(self, err);
	        }
		}
	});

	var options_widget = {
		actionbar: new gc.gis.widget.GCMenu({
			containerClassName: 'gc-imageexport-actionbar',
			items: [
				this._export_button
			]
		})
	};

    gc.gis.widget.GCPanel.call(this, options_widget);

	// Inhalt erzeugen
    this.element = this._render();
    this._initContent();
};
gc.gis.module.GCImageExport.Panel.prototype = Object.create(gc.gis.widget.GCPanel.prototype);

/**
 * Initialisiert den Panel-Inhalt
 *
 * @protected
 * @method
 */
gc.gis.module.GCImageExport.Panel.prototype._initContent = function()
{
	var self = this;

	var form_config = {
		className: 'gc-imageexport-form',
		controls: [
			{
				label: 'Bildformat',
				name: 'format',
				type: 'select',
				options: [
					{
						label: 'PNG',
						value: 'image/png'
					},
					{
						label: 'JPEG',
						value: 'image/jpeg'
					},
					{
						label: 'GIF',
						value: 'image/gif'
					},
					{
						label: 'TIFF',
						value: 'image/tiff'
					},
					{
						label: 'GeoTIFF',
						value: 'image/tiff'
					}
				]
			},
			{
				type: 'checkbox',
				label: 'Georeferenzdaten in separater Textdatei (World file)',
				name: 'worldfile',
				default: false
			}
		],
		validate: function (form, params) {
			if(self._module.map.getRotation() % 360 !== 0)
			{
				throw new gc.gis.error.GCError('Drehwinkel werden beim Bild-Export nicht unterstützt. Bitte richten Sie die Karte nach Norden aus.');
			}
		},
		submit: function (form, params) {
			form.setLoading(true, '');
			self._module.exportImage(params.format, gc.gis.GCUtil.parseBool(params.worldfile, false));
			form.setLoading(false);
		}
	};

	this._form = gc.gis.util.GCFormRenderer.renderForm(form_config);
	this.element_content.append(this._form.getElement());
};